// extracted by mini-css-extract-plugin
module.exports = {"carousel-container":"slider-m__carousel-container__hpzoL","image-element":"slider-m__image-element__1HT-u"};